import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// api
import * as folderAPI from 'api/folder';
import * as folderTypes from 'types/folder';

// ----------------------------------------------------------------------

type schoolBaseActivity = {
  loading: boolean;
  courseResourceList: [];
  folderId: string;
  // courseFolder: {};
  popUpResourceList: { rows: any[]; total: number };
};

const initialState: schoolBaseActivity = {
  loading: false,
  courseResourceList: [],
  folderId: '',
  // courseFolder: {},
  popUpResourceList: { rows: [], total: 0 }
};

const slice = createSlice({
  name: 'folder',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
    },
    hasError(state) {
      state.loading = false;
    },

    setCourseResourceList(state, action) {
      state.courseResourceList = action.payload;
    },
    setFolderId(state, action) {
      state.folderId = action.payload;
    },
    // setCourseFolder(state, action) {
    //   state.courseFolder = action.payload;
    // },
    setPopUpResourceList(state, action) {
      state.popUpResourceList = action.payload;
      state.loading = false;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
// Actions
export const { startLoading, setFolderId } = slice.actions;

// action

// 获取面板数据 (QA full list)
export function get_course_resource_list(params: folderTypes.get_course_resource_list_params) {
  return async () => {
    const { callback } = params;
    dispatch(slice.actions.startLoading());
    try {
      const response = await folderAPI.get_course_resource_list(params);
      // console.log(response);

      dispatch(slice.actions.setCourseResourceList(Array.isArray(response) ? response : []));

      if (callback) {
        callback(response);
      }

      // dispatch(slice.actions.setAddResId(response));
    } catch (error: any) {
      dispatch(slice.actions.hasError());
    }
  };
}

// 獲取新增校本課程題目
export function add_course_folder(params: folderTypes.add_course_folder_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback } = params;
    try {
      const response = await folderAPI.add_course_folder(params);
      console.log(response);

      if (callback) {
        callback(response);
      }

      // dispatch(slice.actions.setCourseLevelPanel(response));
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// // 獲取folder id
// export function get_course_folder_id(params: folderTypes.get_course_folder_id_params) {
//   return async () => {
//     dispatch(slice.actions.startLoading());
//     const { callback } = params;
//     try {
//       const response = await folderAPI.get_course_folder_id(params);
//       console.log(response);

//       if (callback) {
//         callback(response);
//       }

//       dispatch(slice.actions.setCourseFolder(Array.isArray(response) ? response[0] : response));
//     } catch (error) {
//       // dispatch(slice.actions.hasError(error));
//     }
//   };
// }

// 獲取学校资源库列表
export function get_resource_list(params: folderTypes.get_resource_list_params) {
  return async (dispatch: any, getState: any) => {
    dispatch(slice.actions.startLoading());
    const { callback, finallyCallback, offset = 0, limit = 20, ...rest } = params;
    try {
      const response = await folderAPI.get_resource_list({ ...rest, offset, limit });
      console.log(response);

      // Normalize response into { rows, total }
      let payload: { rows: any[]; total: number } = { rows: [], total: 0 };
      if (response && typeof response === 'object' && Array.isArray(response.rows)) {
        payload = {
          rows: response.rows,
          total: typeof response.total === 'number' ? response.total : response.rows.length
        };
      } else if (Array.isArray(response)) {
        payload = { rows: response, total: response.length };
      }

      // If offset > 0, append to existing
      if (offset && offset > 0) {
        const state = getState();
        const existing = state.folder?.popUpResourceList || { rows: [], total: 0 };
        payload = {
          rows: [...(existing.rows || []), ...(payload.rows || [])],
          total: payload.total || existing.total || 0
        };
      }

      if (callback) {
        callback(payload);
      }

      dispatch(slice.actions.setPopUpResourceList(payload));
    } catch (error) {
      dispatch(slice.actions.setPopUpResourceList({ rows: [], total: 0 }));
      dispatch(slice.actions.hasError());
    } finally {
      if (finallyCallback) {
        finallyCallback();
      }
    }
  };
}
